import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    packages: [],
    selectedPackageId:'',
    selectedPackageSponsorshipDetails:{}
};


const packages = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_PACKAGES_LIST: {
      draft.packages = payload?.packages;
      break;
    }

    case Actions.SELECTED_PACKAGE_ID: {
      draft.selectedPackageId = payload?.selectedPackageId;
      break;
    }

    case Actions.SELECTED_PACKAGE_SPONSORSHIP_DETAILS: {
      draft.selectedPackageSponsorshipDetails = payload?.selectedPackageSponsorshipDetails;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default packages;
